import { createRoot } from 'react-dom/client';
import App from './app';
import React from 'react';
const container = document.getElementById('root');
const root = createRoot(container);
import './styles/index.css';
import { AuthProvider } from './contexts/AuthContext';

import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import ThemeProvider from './styles/theme/theme';

root.render(
    <React.StrictMode>
        <AuthProvider>
            <ThemeProvider>
                <App />
            </ThemeProvider>
        </AuthProvider>
    </React.StrictMode>
);
